<template>
  <modal
    :show.sync="showModal"
    :closeOnClick="false"
    modal-classes="modal-dialog-centered"
  >
    <div class="vld-parent" ref="modalInitialInfo">
      <div class="py-3 text-center">
        <img
          class="mx-auto d-block img-fluid mb-3"
          width="30%"
          src="/img/brand/logo_stars_black.png"
        />
        <div class="text-center">
          <h4 class="heading mt-1">Seja bem vindo ao portal Stars!</h4>
          <p>
            Complete as informações para finalizar seu cadasto. Você poderá
            atualizá-lo a qualquer momento na página de Configurações.
          </p>
          <base-progress
            type="warning"
            :striped="true"
            :height="4"
            :showPercentage="false"
            :value="percentage"
          />
        </div>
      </div>
      <form role="form" @submit="handleSubmit">
        <div v-show="step == 1">
          <base-input
            label="Nome da startup"
            v-model="model.startup.name"
            placeholder="Digite o nome de sua startup"
          />
          <base-input
            label="Data de fundação"
            type="date"
            v-model="model.startup.foundation"
            placeholder="Selecione"
          />
          <estados
            estadoLabel="Estado da startup"
            cidadeLabel="Cidade da startup"
            :selectedEstado="model.startup.state"
            :selectedCidade="model.startup.city"
            @inputEstado="model.startup.state = $event"
            @inputCidade="model.startup.city = $event"
          />
        </div>
        <div v-show="step == 2">
          <div class="form-group has-label">
            <base-input
              label="Forneça uma definição sucinta do seu negócio em uma única frase (one-line pitch)"
            >
              <textarea
                rows="2"
                v-model="model.startup.one_sentence_pitch"
                class="form-control"
                placeholder="Uma ou duas linhas devem ser o suficiente :)"
              >
              </textarea>
            </base-input>
          </div>
          <div class="form-group has-label">
            <label class="form-control-label"
              >Qual é o estágio de maturidade atual da sua startup?</label
            >
            <select class="form-control" v-model="model.startup.stage">
              <option value="" selected disabled>Selecione uma opção</option>
              <option
                v-for="stage in Object.keys(stages)"
                :key="'stage_' + stage"
                :value="stage"
              >
                {{ stages[stage] }}
              </option>
            </select>

            <div v-if="model.startup.stage === 'other'">
              <label
                style="font-size: 11px; margin-left: 10px"
                class="form-control-label"
                >Especifique:</label
              >
              <base-input
                style="font-size: 11px; margin-left: 10px"
                v-model="stagesOtherText"
                placeholder="Digite aqui o nome que identifica o estágio"
              />
            </div>
          </div>

          <div class="form-group has-label">
            <label class="form-control-label"
              >Em qual mercado principal sua startup pretende atuar?</label
            >
            <select
              class="form-control"
              v-model="model.startup.bussiness_strategy"
            >
              <option value="" selected disabled>Selecione uma opção</option>
              <option
                v-for="option in bussinesModels"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </div>
          <label class="form-control-label"
            >Em qual(is) setor(es) econômico(s) sua startup atua? Você pode
            informar mais de uma opção.</label
          >
          <v-select
            :components="{ OpenIndicator }"
            class="sector_select"
            multiple
            placeholder="Busque por um setor"
            label="name"
            :options="sectors"
            v-model="model.startup.sector"
            :closeOnSelect="false"
          >
            <template v-slot:option="option">
              <div class="row">
                <div class="col-12 text-left">
                  <span>{{ option.name }}</span>
                </div>
              </div>
            </template>
            <span slot="no-options">Nenhuma opção disponível</span>
          </v-select>
        </div>
        <div v-show="step == 3">
          <base-input
            label="Como você teve conhecimento sobre a Stars? Você conhece alguém que já trabalhou, é investidor ou que faz parte de alguma startup acelerada pela Stars? Se sim, quem?"
          >
            <textarea
              rows="2"
              v-model="model.startup.how_meet_stars"
              class="form-control"
              placeholder="Conta pra gente! :)"
            >
            </textarea>
          </base-input>
          <!--
          <base-input
            label="Alguma observação?"
            v-model="model.startup.note"
            placeholder="Ex: nome de quem indicou, etc."
          />
          -->
        </div>
        <div v-if="error" class="text-center">
          <base-alert type="danger">{{ error }}</base-alert>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <base-button
              type="default"
              class="mt-3"
              :btn-icon-only="true"
              icon="ni ni-bold-left"
              @click="previousStep"
              v-show="step > 1"
            />
            <base-button
              type="default"
              class="mt-3 float-right"
              :btn-icon-only="true"
              icon="ni ni-bold-right"
              @click="nextStep"
              v-if="step < 3"
            />
            <base-button
              v-else
              nativeType="submit"
              type="warning"
              class="mt-3 float-right"
              >Concluir cadastro
            </base-button>
          </div>
        </div>
      </form>
    </div>
  </modal>
</template>
<script>
import api from "@/services/api.js";
import { logout } from "@/services/auth.js";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

export default {
  name: "initial-info-modal-v2",
  props: {
    startupName: {
      type: String,
    },
  },
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      model: {
        startup: {
          name: "",
          foundation: "",
          sector: [],
          bussiness_strategy: "",
          stage: "",
          state: "",
          city: "",
          one_sentence_pitch: "",
          how_meet_stars: "",
          note: "",
        },
      },
      stages: {
        concept: "Ideação",
        validation: "Validação",
        traction: "Tração",
        scale: "Escala",
        other: "Outro",
      },
      stagesOtherText: "",
      OpenIndicator: {
        render: (createElement) =>
          createElement("i", { class: { "toggle fas fa-search": true } }),
      },
      bussinesModels: [
        "Business to Business (B2B)",
        "Business to Consumer (B2C)",
        "Business to Business + Business to Consumer (B2B+B2C)",
        "Business to Government (B2G)",
        "Consumer to Consumer (C2C)",
        "Outros",
      ],
      sectors: [
        "Aeroespacial",
        "Agricultura",
        "Alimentos e bebidas",
        "Biotecnologia",
        "Computadores e periféricos",
        "Construção",
        "Consultoria",
        "Dispositivos e equipamentos médicos",
        "Educação",
        "Eletrônica/instrumentação",
        "Esportes",
        "Estilo de vida",
        "Imóveis",
        "Indústria/energia",
        "Internet/serviços da web",
        "Jogos",
        "Jurídico",
        "Marketing digital",
        "Marketing/publicidade",
        "Marítimo",
        "Mineração",
        "Moda",
        "Mídias e entretenimento",
        "Nanotecnologia",
        "Náutica/Navegação",
        "Petróleo e gás",
        "Produtos da empresa",
        "Produtos de consumo",
        "Redes e equipamentos",
        "Robótica",
        "Segurança",
        "Semicondutores",
        "Serviços a empresas",
        "Serviços ao consumidor",
        "Serviços de saúde",
        "Serviços de TI",
        "Serviços financeiros",
        "Serviços móveis",
        "Software",
        "Substâncias e produtos químicos",
        "Tecnologia limpa",
        "Tecnologia para finanças",
        "Telecomunicações",
        "Transportes",
        "Turismo",
        "Varejo/distribuição",
        "Outro",
      ],
      showModal: false,
      error: "",
      percentage: 0,
      step: 1,
    };
  },
  async mounted() {
    const currentRoute = this.$route.path;

    if (currentRoute !== "/startup" && currentRoute !== "/") {
      return;
    }

    try {
      const { data: calls } = await api.get("/startup-calls?only_open=true");
      const openCall = calls.find((call) => call.status === "open");

      if (!openCall) {
        this.$toasted.error("Nenhuma chamada aberta encontrada.");
        this.$router.push("/startup/chamadas");
        return;
      }

      const today = new Date();
      const startDate = new Date(openCall.start_date);
      const endDate = new Date(openCall.end_date);
      
      if (today < startDate || today >= endDate) {
        this.$router.push("/startup/chamadas");
        return;
      }

      try {
        const { data: subscriptionData } = await api.get(
          `/partial/startup-call-subscriptions?startup_call_id=${openCall.id}`
        );

        if (subscriptionData && subscriptionData.length > 0) {
          const subscription = subscriptionData[0];
          const lastStep = subscription.last_step_completed;

          if (lastStep === null || lastStep === undefined) {
            this.$router.push("/startup/dashboard");
            return;
          }
        }
      } catch (e) {
        console.error("Erro ao verificar progresso da inscrição:", e);
      }

      try {
        await api.get("/startups");
      } catch (e) {
        console.error("Erro ao buscar dados da startup:", e);
      }

      this.$router.push(`/startup/chamadas/${openCall.id}/inscricao`);
    } catch (e) {
      console.error("Erro geral ao buscar dados:", e);
      this.$toasted.error("Erro ao buscar dados.");
      this.$router.push("/");
    }
  },
  methods: {
    async handleSubmit(e) {
      e.preventDefault();
      if (!this.model.startup.how_meet_stars) {
        this.setError();
        return;
      }
      const loader = this.$loading.show({
        container: this.$refs.modalInitialInfo,
        width: 128,
        height: 128,
      });
      const data = this.model.startup;
      try {
        await api.post("/startups", {
          ...data,
          sector: data.sector.toString(),
          stage: data.stage !== "other" ? data.stage : this.stagesOtherText,
        });
        this.percentage += 33.3;
        this.$emit("startup_name", this.model.startup.name);
        this.showModal = false;
        this.$toasted.show("Informações da startup salvas com sucesso");
        this.$router.push("/startup/chamadas");
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao salvar as informações da startup"
        );
        this.setError("Ocorreu um erro ao registar sua conta");
      } finally {
        loader.hide();
      }
    },
    nextStep(e) {
      e.preventDefault();
      if (this.step == 1) {
        this.model.startup.name = this.model.startup.name.trim();
        if (
          !this.model.startup.name ||
          !this.model.startup.foundation ||
          !this.model.startup.state ||
          !this.model.startup.city
        ) {
          this.setError();
          return;
        }
      } else if (this.step == 2) {
        if (
          !this.model.startup.sector.length ||
          !this.model.startup.stage ||
          !this.model.startup.one_sentence_pitch
        ) {
          this.setError();
          return;
        }
      }
      this.error = "";
      this.step++;
      this.percentage += 33.3;
    },
    previousStep(e) {
      e.preventDefault();
      this.error = "";
      this.step--;
      this.percentage -= 33.3;
    },
    setError(msg = "Preencha todos os dados para continuar") {
      this.error = msg;
    },
  },
};
</script>

<style>
.sector_select.v-select {
  background-color: #fff;
  background-clip: padding-box;
  border: none;
  border-radius: 0.375rem;
  font-size: 14px;
}
.sector_select.v-select .vs__dropdown-toggle {
  padding: 6px;
}
.sector_select.v-select .vs__dropdown-toggle .vs__selected-options .vs__search {
  color: #8898aa;
  line-height: 1.5;
  font-weight: 400;
}
</style>
